/* Owns the one-line class joiner every component in the kit uses. Deliberately
   not a tailwind-merge: the kit orders its own classes so the caller's
   `className` always comes last and therefore wins. */

export type ClassValue = string | false | null | undefined

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ')
}

/** Shared id generator for label/description wiring when the caller gave no id. */
let counter = 0
export function nextId(prefix: string): string {
  counter += 1
  return `${prefix}-${counter}`
}
